import { TuiRootModule, TuiDialogModule, TuiAlertModule } from "@taiga-ui/core";
import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { HeaderComponent } from "@estatex/components";
import { FooterComponent } from "./components/footer/footer.component";
import { InventoryStoreModule } from "@estatex/state/inventory/inventory.store.module";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [RouterOutlet, HeaderComponent, TuiRootModule, TuiDialogModule, TuiAlertModule, FooterComponent, InventoryStoreModule],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.css",
})
export class AppComponent {}
